// extracted by mini-css-extract-plugin
var _1 = "CryptoWalletsStyle-module__box-mobile___J_ODg";
var _2 = "CryptoWalletsStyle-module__box-mobile___J_ODg";
var _3 = "CryptoWalletsStyle-module__headline___OUqsZ";
export { _1 as "box-mobile", _2 as "boxMobile", _3 as "headline" }
